import React, { ElementType }  from "react";
import {HeadingStyles} from '../../../types'
import {HEADING_STYLES} from '../../../lib'

type ContentTitlesProps = {
    title?: string;
    id?: string;
    subTitle?: string;
    overline?: string;
    style?: HeadingStyles;
    extraClasses?: string;
    titleComponent?: ElementType;
    subTitleComponent?: ElementType;
    titleClasses?: string;
    subTitleClasses?: string;
    scrambleTitle?: boolean;
};

const ContentTitles = ({
                           overline,
                           title,
                           id,
                           subTitle,
                           titleClasses,
                           subTitleClasses,
                           style = "default",
                           titleComponent: TitleTag = "h3",
                           subTitleComponent: SubTitleTag = "h6",
                           scrambleTitle = false,
                           extraClasses,
                       }: ContentTitlesProps) => {


    const overrideStyle = style ? HEADING_STYLES[style] : HEADING_STYLES[style];

    return (
        <div className={`text-center space-y-1 ${extraClasses}`} id={id}>
            {overline && (
                <h6
                    className="text-sm font-semibold tracking-wide"
                    style={overrideStyle}
                >
                    {overline}
                </h6>
            )}

            {title && (
                <TitleTag
                    className={`text-3xl font-bold slide-right ${titleClasses ? titleClasses : ''} ${
                        scrambleTitle ? "scramble-text" : ""
                    }`}
                    style={overrideStyle}
                >
                    {title}
                </TitleTag>
            )}

            {subTitle && (
                <SubTitleTag
                    className={`text-base opacity-80 ${subTitleClasses ? subTitleClasses : ''}`}
                    style={overrideStyle}
                >
                    {subTitle}
                </SubTitleTag>
            )}
        </div>
    );
};

export default ContentTitles;
